"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStage = exports.StageReactContext = void 0;
var react_1 = require("react");
var utils_1 = require("../utils");
exports.StageReactContext = react_1.createContext(undefined);
exports.useStage = function () {
    var stage = react_1.useContext(exports.StageReactContext);
    if (!stage) {
        throw new utils_1.ReactNGLError('useStage hook can only be used in the children of <Stage>');
    }
    return stage;
};
//# sourceMappingURL=useStage.js.map